import { stringify } from 'qs'

export const API_VERSION = '/api/v1'

export const stringifyQuery = (params) => {
  if (params) {
    return `?${stringify(params)}`
  }
  return ''
}

// 调研工厂测试域名
export const dygcDomain =
  process.env.REACT_APP_JCB_ENV === 'dev'
    ? 'http://test.front.base.survey.work'
    : 'https://survey.work'

export const downloaderUrl =
  process.env.REACT_APP_DEP === 'dev'
    ? 'https://ugm.oss-cn-beijing.aliyuncs.com/ele_download/normal-test/w32/%E4%B8%8B%E8%BD%BD%E5%99%A8normal%E6%B5%8B%E8%AF%95%20Setup%201.1.0.exe'
    : 'https://ugm.oss-cn-beijing.aliyuncs.com/ele_download/normal/w32/ow%E4%B8%8B%E8%BD%BD%E5%99%A8%20Setup%201.2.0.exe'
